import dayjs from "dayjs";
import api from "../../../services/api";
import { errorFormater } from "../../../services/errorHandler";

const optionsToRemove = ["state", "county", "hoa", "city"];
const submitQueue = (set) => async (data, id, isSubmit) => {
  const entity = {
    ...data,
    is_submitted: isSubmit,
  };
  Object.entries(entity).forEach(([key, value]) => {
    if (entity[key] === "") {
      entity[key] = null;
    }
    if (key.endsWith("_expiry_at") && value !== "") {
      entity[key] = dayjs(entity[key]).format("YYYY-MM-DD");
    }
  });

  optionsToRemove.forEach((option) => delete entity[option]);
  try {
    set({ isLoading: true });
    await api.put(`/queues/${id}/response/`, entity);
    set({ isLoading: false });
  } catch (error) {
    set({ isLoading: false });
    throw errorFormater(error.response);
  }
};

export default submitQueue;
